module.exports = __webpack_public_path__ + "img/HYPER_VARIATION_A1014.6c334acf.png";